import { Stack, Tag, TagVariant, Typography } from '@optimus-web/core';

interface NoteItemProps {
    tag?: React.ReactNode;
    text: React.ReactNode;
    footer: React.ReactNode;
    tagVariant?: TagVariant;
}

export const NoteItem = ({ tag, text, footer, tagVariant }: NoteItemProps) => (
    <Stack vertical spacing="100" itemAlignment="start">
        {tag ? <Tag variant={tagVariant}>{tag}</Tag> : null}
        <Typography textStyle="bodyMedium" variant="primary" as="div">
            {text}
        </Typography>
        <Typography textStyle="bodySmall" variant="secondary" as="div">
            {footer}
        </Typography>
    </Stack>
);
